import React from 'react';

import { EnforceMfaContent } from '@/shared/features/rbac/components/enforce-mfa-warning/enforce-mfa-content';
import { useLoggedInUser } from '@/shared/hooks/use-logged-in-user/use-logged-in-user';
import { useTermsAndConditions } from '@/shared/hooks/use-terms-and-conditions/use-terms-and-conditions';
import { useReadTenantQuery } from '@/shared/redux/api/ident/ident-api';

export const EnforceMfaWarning = () => {
  const { isSsoUser, isMfaEnabled } = useLoggedInUser();
  const { isLatestAccepted } = useTermsAndConditions();
  const { data: tenantData } = useReadTenantQuery();

  const mfaEnforced = Boolean(tenantData?.readTenant?.enforceMfa);
  const userEnforced =
    mfaEnforced && !isMfaEnabled && !isSsoUser && isLatestAccepted;

  return <EnforceMfaContent display={userEnforced} />;
};
